export const headCells = [
  {
    id: "UserName",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Login ID",
    width: 150,
  },
  {
    id: "FirstName",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "First Name",
    width: 150,
  },
  {
    id: "LastName",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Last Name",
    width: 150,
  },
  {
    id: "Email",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Email ID",
    width: 220,
  },
  {
    id: "Role",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Role",
    width: 250,
  },
  {
    id: "Status",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Status",
    width: 150,
  },
  {
    id: "Action",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "Action",
    width: 150,
  },
];

export const rowsPerPageOptions = [10, 25, 50, 100];
